<template>
  <span
    class="darwin-icon"
    :class="`icon-${name}`"
    v-bind="$attrs"
  >
    <component
      :is="icon"
      :size="($attrs as IconProps).size ?? 16"
    />
  </span>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { icons, type IconNames } from './icons'

type IconProps = {
  size?: number
}

const props = defineProps<{ name: IconNames }>()

const icon = computed(() => icons[props.name])
</script>

<style lang="scss" scoped>
.darwin-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 20px;
  aspect-ratio: 1 / 1;
  font-size: 16px;
}
</style>
